import { supabase } from '@/lib/supabase';
import { Row } from '@/shared/types/api';

type OrgMember = Row<'org_members'>;

export const getOrgMember = async (
  orgId: number,
  userId: string,
): Promise<OrgMember> => {
  const { data, error } = await supabase
    .from('org_members')
    .select('*')
    .eq('org_id', orgId)
    .eq('user_id', userId)
    .single();

  if (error) {
    throw error;
  }

  return data;
};
